import { Plus, Search } from "lucide-react";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import "../../global.css";
import { bankingPartnerAPI } from "../../services/AdminPortal/api";
const BankingPartner = () => {
  const { sidebarExpanded, isMobile } = useSidebar();
  const navigate = useNavigate();
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [bankingPartners, setBankingPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBankingPartners();
  }, []);

  const fetchBankingPartners = async () => {
    try {
      setLoading(true);
      const response = await bankingPartnerAPI.getAll();
      if (response.success !== true) {
        throw new Error("Failed to fetch banking partners");
      }
      const transformedData = response.data.map((partner) => ({
        name: partner.bankName,
        category: partner.bankCategory,
        assignedFiles: "0",
        processedFiles: "0",
        pendingFiles: "0",
        approvalRate: "0%",
        processingTime: "0 Days",
        subText: partner.branchName,
        id: partner._id,
        status: partner.status,
        representative: partner.representative,
        loanManagement: partner.loanManagement,
        compliance: partner.compliance,
        branchIFSCCode: partner.branchIFSCCode,
        bankAddress: partner.bankAddress,
      }));

      setBankingPartners(transformedData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleViewPartner = (partnerIndex) => {
    navigate(`${partnerIndex}`);
  };

  const handleSelectAll = () => {
    setSelectedAll(!selectedAll);
    if (!selectedAll) {
      setSelectedRows(bankingPartners.map((_, index) => index));
    } else {
      setSelectedRows([]);
    }
  };

  const handleCheckboxChange = (index) => {
    const updatedSelection = selectedRows.includes(index)
      ? selectedRows.filter((i) => i !== index)
      : [...selectedRows, index];
    setSelectedRows(updatedSelection);
    setSelectedAll(updatedSelection.length === bankingPartners.length);
  };

  const filteredPartners = bankingPartners.filter((partner) =>
    partner.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div
      className="min-h-screen bg-black text-white   mt-12"
      style={{
        marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
        width: isMobile
          ? "100%"
          : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
      }}
    >
      <TopNavbar />
      <div className="p-4 md:p-6">
        <div className="flex items-center justify-between mb-6 mt-6">
          <h1 className="text-xl">Banking Partners</h1>
          {/* <button
            className="px-4 py-2 bg-[#FFCA20] text-black rounded-lg text-sm font-medium flex items-center gap-2"
            onClick={() => navigate("add-partners")}
          >
            <Plus size={16} />
            Add Banking Partner
          </button> */}
        </div>

        {/*  Search Input with Icon */}
        <div className="relative w-full sm:w-64 my-2 text-customWhite">
          <div className="absolute left-3 top-2.5 text-gray-400">
            <Search size={16} />
          </div>
          <input
            type="text"
            placeholder="Search Partners"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="bg-bgBackground rounded-lg px-10 py-2 text-sm w-full border border-[#333333]"
          />
        </div>

        <div className="p-4">
          <p className="text-sm text-customWhite">
            Select to enable bulk options{" "}
            <span className="ml-2 text-sm text-blue-400">
              ({selectedRows.length} selected)
            </span>
          </p>
        </div>

        {/*  Responsive Table Wrapper */}
        <div className="  bg-[#131313] rounded-lg border border-[#333333] w-full  overflow-x-auto scrollbar-hide">
          <table className="min-w-full">
            <thead className="border-y border-[#333333]">
              <tr className="text-left text-sm">
                <th className="p-4 border border-[#333333]">
                  <input
                    type="checkbox"
                    checked={selectedAll}
                    onChange={handleSelectAll}
                    className="appearance-none h-5 w-5 border-2 border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
                      before:content-['✓'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                  />
                </th>
                <th className="p-4 border border-[#333333]">BANK NAME</th>
                <th className="p-4 border border-[#333333]">CATEGORY</th>
                <th className="p-4 border border-[#333333]">ASSIGNED FILES</th>
                <th className="p-4 border border-[#333333]">PROCESSED FILES</th>
                <th className="p-4 border border-[#333333]">PENDING FILES</th>
                <th className="p-4 border border-[#333333] w-[250px]">
                  APPROVAL RATE AND AVG PROCESSING TIME
                </th>
                <th className="p-4 border border-[#333333]">ACTIONS</th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {filteredPartners.length === 0 ? (
                <tr>
                  <td colSpan="8" className="p-6 text-center text-gray-400">
                    No rows found
                  </td>
                </tr>
              ) : (
                filteredPartners.map((partner, index) => (
                  <tr key={index} className="border-b border-[#333333]">
                    <td className="p-4 border border-[#333333]">
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(index)}
                        onChange={() => handleCheckboxChange(index)}
                        className="appearance-none h-5 w-5 border-2 border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
                      before:content-['✓'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                      />
                    </td>
                    <td className="p-4 border border-[#333333]">
                      <div>
                        {partner.name}
                        {partner.subText && (
                          <div className="text-xs text-gray-400">
                            {partner.subText}
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="p-4 border border-[#333333]">
                      {partner.category}
                    </td>
                    <td className="p-4 border border-[#333333]">
                      {partner.assignedFiles}
                    </td>
                    <td className="p-4 border border-[#333333]">
                      {partner.processedFiles}
                    </td>
                    <td className="p-4 border border-[#333333]">
                      {partner.pendingFiles}
                    </td>
                    <td className="p-4 border border-[#333333]">
                      <div className="flex items-center   justify-between">
                        <span
                          className={`text-sm ${
                            parseInt(partner.approvalRate) >= 90
                              ? "text-green-500"
                              : parseInt(partner.approvalRate) >= 80
                              ? "text-customYellow"
                              : "text-red-500"
                          }`}
                        >
                          {partner.approvalRate}
                        </span>
                        <span className="text-gray-400">
                          {partner.processingTime}
                        </span>
                      </div>
                    </td>
                    <td className="p-4 border border-[#333333]">
                      {/* onClick={() => navigate(`/banking-partner/${index}`)} */}

                      <button
                        className="text-customYellow bg-transparent underline text-sm"
                        onClick={() => handleViewPartner(partner.id)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BankingPartner;
